import { List } from 'immutable'
import {
  getPmSectionType,
  TYPE_PLACEMENT,
  TYPE_MEMBER_HOME_FIRST_TOUCH,
} from '../../../pm-section/index'
import { selectSectionsIds, selectReadyToRenderSections } from '../common'
import { sectionStatus } from '../../entities'

const getSectionsStatus = (sectionIds) => {
  if (sectionIds.isEmpty()) {
    return sectionStatus.EMPTY
  }
  return sectionStatus.READY
}

const isNotSpotlight = (sectionType) => sectionType !== TYPE_PLACEMENT

const isRenderableHomeRow = (sectionType) => (
  sectionType
  && sectionType !== TYPE_MEMBER_HOME_FIRST_TOUCH
)

export function selectHomeSections (state) {
  const sectionIds = selectSectionsIds(state)
  const readySectionIds = selectReadyToRenderSections(state)
  const { pmSection } = state

  // Ensure readySectionIds is a List
  const readySectionIdsList = List.isList(readySectionIds)
    ? readySectionIds
    : List(readySectionIds)

  let rowPlacementCount = 0

  const sections = readySectionIdsList
    .filter((sectionId) => {
      const sectionType = getPmSectionType({ pmSection, sectionId })
      return isRenderableHomeRow(sectionType)
    })
    .map((sectionId) => {
      const sectionType = getPmSectionType({ pmSection, sectionId })
      let rowPlacement = null

      // This condition was requested by the data team since we were previously taking into
      // account the Spotlight but, they wanted to ignore this row for GA work related.
      if (isNotSpotlight(sectionType)) {
        rowPlacement = rowPlacementCount
        rowPlacementCount += 1
      }
      return {
        sectionId,
        rowPlacement,
        sectionType,
      }
    })

  const status = getSectionsStatus(sectionIds, readySectionIdsList)

  return {
    status,
    items: sections,
  }
}

export default selectHomeSections
